import styles from './styles';

function HealthIndicator({ className, style, classes, health, variant }) {
  return (
    <div
      style={style}
      className={classnames(classes.root, className, {
        [classes.whiteVariant]: variant === 'white',
      })}>
      {[1, 2, 3, 4, 5].map((healthLevel) => (
        <div
          className={classnames(classes.bar, {
            [classes.barSelected]: health >= healthLevel,
          })}
          key={healthLevel}
        />
      ))}
    </div>
  );
}

HealthIndicator.defaultProps = {
  health: 0,
  variant: 'normal',
};

HealthIndicator.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  health: PropTypes.oneOf([0, 1, 2, 3, 4, 5, null]),
  variant: PropTypes.oneOf(['normal', 'white']),
  style: PropTypes.object,
};

export default withStyles(styles)(HealthIndicator);
